import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class WorkflowUserService {

	constructor(
		private configService: ConfigService,
		private http: HttpClient
	) { }
	
	async getGroups(): Promise<any> {
		let url = this.configService.getConfig().dx.groupsURL;

		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async getParticipantsByGroup(group: string, addSuperviors: boolean = false): Promise<any> {
		let url = this.configService.getConfig().dx.groupsURL;
		url += `/${group}`;
		url += `?includeSupervisors=${addSuperviors}`;

		try {
			const response = await firstValueFrom(this.http.get<any>(url, {}));

			let users = response;
			users.forEach((user: any) => {
				this.formatUser(user);
			});
			return users;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async getPotentialTaskOwners(taskids: any[], username?: string | null): Promise<any> {
		let url = this.configService.getConfig().dx.usersURL;
		url += `/assignable/task`;
		if (username) {
			url += `?filter=${username}`;
		}

		try {
			const response = await firstValueFrom(this.http.post<any>(url, taskids));

			let users = response;
			users.forEach((user: any) => {
				this.formatUser(user);
			});
			return users;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	private formatUser(user: any) {
		if (!user) return;
		
		user.displayName = user.lastName + ', ' + user.firstName + '(' + user.username + ')';
	}		
}
